<div [ngClass]="{ lightMode: user && user.lightmode, darkMode: user && !user.lightmode }">
  <router-outlet></router-outlet>
  <div class="loading-shade" *ngIf="loading || sessionRestoring">
    <mat-spinner></mat-spinner>
  </div>
</div>
